const messages = {
  // ================================================================
  // ACTIONS
  reset: 'Reset',
  save: 'Save',
  update: 'Update',
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  create: 'Create',
  search: 'Search',
  accept: 'Accept',
  add: 'Add',
  login: 'Login',
  access: 'Access',
  logout: 'Logout',
  recover: 'Recover',
  finalize: 'Close and send',
  send: 'Send',
  invite: 'Invite',
  close: 'Close',
  reopen: 'Reopen',

  // custom
  upload: 'Upload {field}',
  change: 'Change {field}',
  select: 'Select {field}',
  // ================================================================
  // MODELS
  match: 'Match | Matches',
  language: 'Language | Languages',
  country: 'Country | Countries',
  province: 'Province | Provinces',
  town: 'City | Cities',
  category: 'Category | Categories',
  entity: 'Entity | Entities',
  team: 'Team | Teams',
  user: 'User | Users',
  act: 'Act | Acts',
  aspect: 'Aspect | Aspects',
  stadium: 'Stadium | Stadiums',
  pitch: 'Pitch | Pitches',
  role: 'Role | Roles',
  tournament: 'Tournament | Tournaments',
  phase: 'Phase | Phases',
  group: 'Group | Group',
  advertising: 'Ad | Ads',
  course: 'Course | Courses',
  event: 'Event | Events',
  // list name
  rolList: 'Role List',
  items: 'Items',
  // ================================================================
  new: 'New',
  // ================================================================
  // TITLES / LABELS
  // global
  dashboard: 'Dashboard',
  admin: 'Admin',
  apps: 'Apps',
  management: 'Management',
  config: 'Config',
  state: 'State',
  chronometer: 'Chronometer',
  simpleChronometer: 'Simple Chronometer',
  yes: 'Yes',
  no: 'No',
  previous: 'Previous',
  next: 'Next',
  none: 'None',
  termsAndConditions: 'Terms and Conditions',
  termsOfUse: 'Terms of Use',
  newModel: 'New {field}',
  newAModel: 'New {field}',
  updateModel: 'Update {field}',
  deleteModel: 'Delete {field}',
  addField: 'Add {field}',
  information: 'Information',
  generalInformation: 'General Information',
  score: 'Score',
  typeScore: 'Score type',
  untilScore: 'Score Limit',
  value: 'Value',
  option: 'Option',
  options: 'Options',
  content: 'content',
  confirmDelete: 'Confirm to delete {field} <b>{name}</b>.',
  confirmADelete: 'Confirm to delete {field} <b>{name}</b>.',
  confirmClone: 'Confirm to clone {field}',
  titleFile: 'Upload file',
  // matches
  result: 'Result',
  faults: 'Faults',
  total: 'Total',
  matchResult: 'Match Result',
  homeTeamTitle: 'home team',
  visitorTeamTitle: 'visitor team',
  homeTeamResult: 'Home team result',
  visitorTeamResult: 'Visitor team result',
  confirmDeleteMatchFromGroup: 'Confirm delete match from group.',
  addEvent: 'Add event',
  // users / profiles
  userInformation: 'User Information',
  personalData: 'Personal Information',
  accountData: 'Account Information',
  profile: 'Profile',
  man: 'Male',
  woman: 'Female',
  noRole: 'No role',
  // acts
  notFaultSystem: 'Fault system disabled.',
  confirmation: 'Confirmation',
  confirmDeleteAct: 'Confirm delete action.',
  addCategory: 'Add Category',
  addType: 'Add Type',
  categoryEmpty: 'Empty Category.',
  mainData: 'Main Information',
  categoryAssign: 'Category Assignment',
  aspectAssign: 'Aspect Assignment',
  ifFaultSystem: 'Fault System?',
  smallFaultValue: 'Small fault value',
  seriousFaultsValue: 'Serious faults value',
  // aspects
  checkbox: 'Checkbox',
  dropdown: 'Select',
  textbox: 'Textbox',
  // categories
  parentCategory: 'Parent Category',
  newCategoryWithParent: 'New child Category',
  // entities
  client: 'Client',
  siteUrl: 'Site Url',
  defaultLanguage: 'Default Language',
  // roles
  description: 'Description',
  permissions: 'Permissions',
  // tournaments
  participant: 'Participant',
  participants: 'Participants',
  table: 'Table',
  clasification: 'Clasification',
  videos: 'Videos',
  isConfirmed: 'Confirmed?',
  ifAccepted: 'Accepted?',
  ifInvitationSent: 'Invitation Sent?',
  left: 'Left',
  ifShowResults: 'Show Results?',
  ifRandomMatches: 'Random Matches?',
  finished: 'Finished',
  complete: 'Complete',
  byUsers: 'By users',
  byTeams: 'By teams',
  position: 'Position',
  points: 'Points',
  participantsQuantity: 'Participants quantity',
  dates: 'Dates',
  openAct: 'Open act',
  duplicate: 'Duplicate',
  // phases
  ranking: 'Ranking',
  winners: 'Winners',
  // groups
  noGroup: 'No group',
  // ================================================================
  // FIELDS
  // reset password
  newPassword: 'New Password',
  repeatPassword: 'Repeat Password',
  // global
  createdAt: 'Create dAt',
  updatedAt: 'Updated At',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  actions: 'Actions',
  active: 'Active',
  name: 'Name',
  type: 'Type',
  types: {
    tournament: 'Tournament',
    league: 'League',
    friendly: 'Friendly',
    user: 'User'
  },
  date: 'Date',
  time: 'Time',
  location: 'Location',
  order: 'Order',
  // dashboard
  notActive: 'Not Active',
  deleted: 'deleted',
  // usuarios
  username: 'Username',
  validated: 'Validated',
  lastname: 'First Surname',
  lastname2: 'Second Surname',
  email: 'Email',
  password: 'Password',
  sex: 'Gender',
  birthdayDate: 'Birthday Date',
  address: 'Address',
  cp: 'Postal Code',
  phone: 'Phone',
  userImage: 'Image',
  image: 'Image',
  lastAccess: 'Last access',
  // matches
  finalized: 'Finished',
  all: 'All',
  notFinalized: 'Not Finished',
  judges: 'Judges',
  homeTeam: 'Home team',
  visitorTeam: 'Visitor team',
  video: 'Video',
  youtubeVideo: 'Youtube Video',
  warnings: 'Warnings',
  smallFaults: 'Small Faults',
  seriousFaults: 'Serious Faults',
  // eventsCreated
  additionalContent: 'Additional content',
  minute: 'Minute',
  second: 'Second',
  // languages
  iso: 'ISO',
  // tournaments
  startAt: 'Start At',
  endAt: 'End At',
  confirmed: 'Confirmed',
  accepted: 'Accepted',
  usersTeams: 'Users by Teams',
  showRanking: 'Show Ranking',
  openInscription: 'Open Inscription',
  numberParticipants: 'Max number of {field}',
  randomMatches: 'Random Matches',
  hours: 'Hours',
  inscription: 'Inscription',
  // phases
  typePlayOff: 'PlayOff type',
  toClass: 'To class',
  matchesByParticipant: 'Matches by participant',
  // stats
  stats: 'Statistics',
  actStats: 'Act Statistics',
  tournamentStats: 'Tournament Statistics',
  userStats: 'User Statistics',
  stanceResult: 'Distribución de Posturas',
  wonLostResult: 'Datos Cualitativos del Equipo',
  average: 'Average',
  won: 'Won',
  lost: 'Lost',
  // Anuncios (advertising)
  chronometerSimple: 'Simple chronometer',
  chronometerMatch: 'Match chronometer',
  boardTournament: 'Board tournament',
  leftRankingTournament: 'Tournament classification left',
  rightRankingTournament: 'Tournament classification right',
  adsImage: 'Image of the advertisement',
  width: 'Width',
  height: 'Height',
  adsLocation: 'Location',
  // Chronometers
  categoryAspectBase1: 'Exp. Inicial',
  categoryAspectBase2: 'Ref. Argumentativa',
  categoryAspectBase3: 'Ref. Dialéctica',
  categoryAspectBase4: 'Ref. Dialética 2',
  categoryAspectBase5: 'Ref.Dialéctica 3',
  categoryAspectBase6: 'Ref. Dialéctica 4',
  categoryAspectBase7: 'Conclusión',
  // ================================================================
  // ERRORS
  error: {
    // global
    userNotFound: 'User not found.',
    empty: 'The field is required.',
    invalidEmail: 'Invalid email.',
    passwordDoNotMatch: 'Passwords does not Match.',
    min: 'Value must be equal or greater than {field}',
    minNumber: 'Value must be equal or greater than {field}.',
    maxNumber: 'Value must be equal or lesser than {field}.',
    required: 'Field {field} is required.',
    resultsNotFound: 'Results not found.',
    modelNotFound: '{field} not found.',
    modelANotFound: '{field} not found.',
    nameSpanish: 'Name is required in Spanish',
    // matches
    equalTeams: 'Home team and visitor teams must be different.',
    invalidYoutubeVideo: 'The link is not a valid Youtube video.',
    // users
    rolesIncomplete: 'Roles have not been selected completely.',
    roleError: 'Error in role: ',
    // tournaments
    invalidType: 'Invalid Type.',
    oneRequired: 'At least one {field} must be selected.',
    oneARequired: 'At least one {field} must be selected.',
    invalidParticipantsRange:
      'Number of participants must be between 1 and 100.',
    emptyStadium:
      'Careful!. The Stadium <b>{field}</b> does not have Pitches assigned.',
    emptyStadiums: 'The selected Stadiums do not have Pitches assigned.',
    // phases
    orderInUse: 'A phase with order {field} already exists.',
    // advertising
    invalidMinImage: 'The {field} of the image is not correct',
    // api responses
    timeout: 'Connection timeout.',
    notConnection: 'Internet connection unavailable',
    messageNotDefined: 'Message error not defined.',
    sessionExpired: 'The current session has expired, please login again.',
    validationError: 'Validation error.'
  },
  // ================================================================
  // MESSAGES
  messages: {
    // global
    loading: 'Loading...',
    searching: 'Searching...',
    fieldRequired: 'Required field.',
    // reset password
    lostPassword: 'Enter your account email.',
    setNewPassword: 'Enter your new password.',
    forgotPassword: 'Forgot password?',
    // matches
    resultModified: 'Result Manually Modified.',
    judgeResults: 'Selected judge score.'
  }
}

export default messages
